require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-new-workspace-welcomes-students-for-their-first-day-photos.json") })
        }
      }, "path---blog-new-workspace-welcomes-students-for-their-first-day-photos");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-new-workspace-welcomes-students-for-their-first-day-photos!./.cache/json/blog-new-workspace-welcomes-students-for-their-first-day-photos.json
// module id = 1000
// module chunks = 231608221292675